// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7dc938b1] .lines-2{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;height:72px}@media (min-width:768px){[data-v-7dc938b1] .lines-2{height:auto;-webkit-line-clamp:unset}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
